/** datetime-local values belong to the company's zone, not the device's zone. */
export function cashExpenseLocalDate(date, timezone) {
    const parts = new Intl.DateTimeFormat('en-GB', { timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).formatToParts(date);
    const p = (name) => parts.find(part => part.type === name)?.value || '';
    return `${p('year')}-${p('month')}-${p('day')}T${p('hour')}:${p('minute')}:${p('second')}`;
}
export function cashExpenseDateIso(value, timezone) {
    value = value.replace(/\.0+$/, '');
    if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?$/.test(value))
        return null;
    const desired = Date.parse(value + (value.length === 16 ? ':00' : '') + 'Z');
    if (!Number.isFinite(desired))
        return null;
    let instant = desired;
    for (let i = 0; i < 3; i++) {
        const local = Date.parse(cashExpenseLocalDate(new Date(instant), timezone) + 'Z');
        const offset = local - instant;
        instant = desired - offset;
    }
    const normalized = value.length === 16 ? value + ':00' : value;
    return cashExpenseLocalDate(new Date(instant), timezone) === normalized ? new Date(instant).toISOString() : null;
}
